// extracted by mini-css-extract-plugin
module.exports = {"select":"forms_select__WN0r3","inputField":"forms_inputField__JeGvE"};